import { render, staticRenderFns } from "./OBooleanSelect.vue?vue&type=template&id=0f496ca9&scoped=true&"
import script from "./OBooleanSelect.vue?vue&type=script&lang=js&"
export * from "./OBooleanSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f496ca9",
  null
  
)

export default component.exports